import React from "react";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import Posts from "../components/Posts";
import AddPost from "../components/AddPost";
import IsLoading from "../components/IsLoading";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function App({ animationDuration }) {
  const [user, isLoading] = useAuthState(auth);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={`min-h-screen bg-gray-900 ${
        isLoading ? "justify-center items-center" : ""
      }`}
    >
      {isLoading ? (
        <IsLoading />
      ) : (
        <>
          <Navbar />
          <div className="container mx-auto p-4">
            <div className="flex flex-col justify-center items-center bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
              <AddPost />
            </div>
            <div>
              <Posts />
            </div>
          </div>
        </>
      )}
      <Footer />
    </motion.div>
  );
}
